<div class="home-accounts-item">
  <div class="home-accounts-item-title">{{ getAccountKindName(accountHomepage?.account) | translate }}</div>
  <div class="home-accounts-item-chart" *ngIf="accountKind !== 'ci'; else ciInvestorData">
    <div class="home-accounts-item-chart-loading" *ngIf="!accountHomepage?.graphData?.initialised">
      <ion-spinner name="lines"></ion-spinner>
    </div>
    <app-home-area-chart
      *ngIf="
        accountHomepage?.graphData?.initialised &&
          accountHomepage?.endValues?.initialised &&
          accountHomepage?.graphData?.graphData.length &&
          !hasError();
        else notAvailable
      "
      [data]="accountHomepage?.graphData?.graphData"
      [status]="accountHomepage?.endValues?.endValues?.return_all_net > 0 ? 'positive' : 'negative'"
    ></app-home-area-chart>
    <ng-template #notAvailable>
      <p *ngIf="accountHomepage?.graphData?.initialised && accountHomepage?.endValues?.initialised">
        {{ (accountKind === '3a' ? 'home.investments.upgrade_3a' : 'home.investments.notavailable') | translate }}
      </p>
    </ng-template>
  </div>
  <div
    class="home-accounts-item-performance"
    [class.loading]="!accountHomepage?.endValues?.initialised"
    *ngIf="accountKind !== 'ci'; else ciInvestorPerformance"
  >
    <p>
      <span>{{ currencyInvestment }}</span>
      {{ accountHomepage?.endValues?.endValues?.end_value.toFixed(0) | thousand }}
    </p>
    <p *ngIf="accountHomepage?.endValues?.endValues?.profit_all">
      {{ accountHomepage?.endValues?.endValues?.profit_all.toFixed(0) | thousand: currencyInvestment : true }}
    </p>
    <ion-skeleton-text animated></ion-skeleton-text>
    <ion-skeleton-text animated></ion-skeleton-text>
  </div>
</div>

<ng-template #ciInvestorData>
  <div class="home-accounts-item-chart">
    <ion-icon name="insights-f"></ion-icon>
  </div>
</ng-template>

<ng-template #ciInvestorPerformance>
  <div class="home-accounts-item-performance" [class.loading]="crowdinvestingTotalValue === 0">
    <p>
      <span>{{ currencyShares }}</span>
      {{ crowdinvestingTotalValue | thousand }}
    </p>
    <ion-skeleton-text animated></ion-skeleton-text>
  </div>
</ng-template>
